import { MDBCol, MDBInput, MDBRow, MDBBtn } from "mdb-react-ui-kit";
import React, {
  useMemo,
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import Modal_Clientes from "./Customer_Modal";
import tache from "../../assets/TACHE NOTARIA.png";
import { useUsuarioStore } from "../zustandShared/usuarioStore";
import axios from "axios";
import { Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import URLAPI from "../../helpers/Path";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import palomita from "../../assets/pngegg.png";
//Modal del checklist
import CheckListModal from "./checkListModal";
import Alerts from "../Alerts";
import Alert_modal from "../alert_modal";
import { set } from "date-fns";

const Integration = ({ childcomponent, idCotizacion }) => {

    //Creamos unas variables de estado de respaldo de array inmuebles y numero de inmuebles para detectar cambios
    const [respaldoNo_Inmuebles, setRespaldoNo_Inmuebles] = useState(0);
    const [respaldoArray_Inmuebles, setRespaldoArray_Inmuebles] = useState([]);
  //Referencia que pedira la lista de expedientes
  const expedientesphp = URLAPI + "info_expediente.php";
  //Creamos una variable que guardara todos los diferentes expedientes
  const [expedientes, setExpedientes] = useState([]);
  //Creamos una variable de estado que solo se va a ejecutar al inicio de recargar la pagina, para que sea de ayuda al momento de cargar los datos
  const [isFirstLoad, setIsFirstLoad] = useState({});
  //Creamos una variable de estado para mostrar un mensaje cuando no se encontraron datos para el expediente buscado
  const [dataEmpty, setDataEmpty] = useState(false);


  //Creamos una variable de estado de tipo array, para añadirle a los documentos del checklist e indicar si estos estan habilitados o estan seleccionados
  const [documentoE, setDocumentoE] = useState([]);
  const [documentoArray, setDocumentoArray] = useState([]);
  //Referencia para el autocomplete
  const inputRef = useRef(null);
  //Estado para el alert de que se detectaron cambios
  const [isAlert5, setIsAlert5] = useState(false);
  //Creamos una variable de estado donde se guardara el input que funcionara con el autocompletado
  const [search, setSearch] = useState("");
  // ------------------------------------------------------------------------
  const [isalert4, setisAlert4] = useState(false);
  //Insertamos una variable de estado boolena que hara que se muestre el formulario o no, segun cuando el usuario haya realizado la busqueda
  const [showFormulario, setShowFormulario] = useState(false);
  // Obtenemos ID de usuario mediante URL
  const { id_user } = useParams();
  //Creamos una variable de estado para ocultar el div cuando se le da el valor de siguiente
  const [ocultarFormulario, setOcultarFormulario] = useState(false);
  //Obtenemos los elementos de bool para hacer mas manejable el formqua con los elementos de integracción y otorgación
  const { setBoolElemento, documentosGuardados, deleteDocumentosGuardados } =
    useUsuarioStore();
  // Variable variante de comparación por si hubo un cambio
  const [varianteBackup, setVarianteBackup] = useState(0);
  // Variable rama de comparación por si hubo un cambio
  const [ramaBackup, setRamaBackup] = useState(0);
  // Variable acto de comparación por si hubo un cambio
  const [actoBackup, setActoBackup] = useState(0);
  // Variable opcion de comparacion por si hubo un cambio
  const [opcionBackup, setOpcionBackup] = useState(0);
  //Creamos una variable de estado para cuando se logre guardar de forma correcta los datos
  const [dateSearch, setDateSearch] = useState(false);
  //Creamos una variable de estado de tipo string para que guarde el data de folio
  const [fol, setFol] = useState("");
  //Variable para guardar el consecutivo del expediente
  const [exp_Consecutivo, setExp_Consecutivo] = useState("");
  //Variable para guardar el numero de escritura
  const [no_escritura, setNo_Escritura] = useState("");

  //Variable de estado para quitar el elemento de aviso de agregar al menos un integrante o un otorgante

  const [isAlerts3, setIsAlert3] = useState(false);
  //Guardar hecho legal
  const [verification_legalact, setName_LegalAct_verification] = useState("");

  //Creamos una variable de estado con la que se hara la comparativa de que si se cambio el respaldo
  const [inmuebleBackup2, setInmuebleBackup2] = useState([]);

  //Creamos una variable de estado para comparar si hubo cambios en variante
  const [selectedVarianteBackup, setselectedVarianteBackud] = useState(0);

  //Creamos una variable de estado para comparar si hubo cambios en rama

  const [selectedRamaBackup, setselectedRamaBackup] = useState(0);

  //Creamos una variable de estado para comparar si hubo cambios en acto

  const [selectedActoBackup, setselectedActoBackup] = useState(0);

  //Creamos una variable de estado para comparar si hubo cambios en opcion

  const [selectedOpcionBackup, setselectedOpcionBackup] = useState(0);

  const [fecha_firma, setfecha_firma] = useState(null);

  //Creamos una variable de estado de tipo bool que ayudara a la detección de si se produjo un cambio
  const [detectarCambios, setDetectarCambios] = useState(false);

  //Variable de estado para guardar una copia de los datos de inmueble
  const [inmuebleBackup, setInmuebleBackup] = useState([]);

  //Variable de estado para recargar la pagina
  const [isCreated, setIsCreated] = useState(false);

  //Aqui mandamos el acto
  const requisitos = URLAPI + "requisitos.php";

  //Variables para los archivos
  const poparchivosURL = URLAPI + "poparchivos_exp.php";
  const tempo_archivos = URLAPI + "tempo_archivos_exp.php";
  const [archive, setArchive] = useState([]);
  const borra_archivo = URLAPI + "borra_archivo_exp.php";
  const archivo_fecharef = useRef(null);

  //Obtenemos la pagina para obtener el presupuesto
  const presupuesto = URLAPI + "presupuesto.php";
  //Objeto para guardar las fechas de vigencia
  const [fechas, setFechas] = useState({});

  //Variable que maneja el alert si no se ha seleccionado el acto
  const [isAlert, setIsAlert] = useState(false);

  //Variables para guardar los nombres de adquirientes y otorgantes
  const [nombreAdquiriente, setNombreAdquiriente] = useState([]);
  const [nombreOtorgante, setNombreOtorgante] = useState([]);

  // Funcion que se usa par recargar la pagina cuando se aparece el alert de guardado exitoso

  useEffect(() => {
    if (isCreated) {
      window.location.reload();
    }
  }, [isCreated]);
  // --------------------------------------------------------------------------------------------------------------------------

  /*
    console.log("se mando:", childcomponent)
    console.log("Se mando el id:", idCotizacion)

  useEffect(() => {
    console.log("se mando:", childcomponent)
    console.log("Se mando el id:", idCotizacion)
  }, childcomponent)
// ------------------------------------------------------------------------------------------------------------------
*/

  // Input Titular

  const [nameTitular, setNameTitular] = useState("");
  // Listas
  const [listRamas, setListRamas] = useState([]);
  const [listActos, setListActos] = useState([]);
  const [listVariantes, setListVariantes] = useState([]);
  const [listOpciones, setListOpciones] = useState([]);

  // Selects
  const [selectedRama, setSelectedRama] = useState(0);
  const [selectedActo, setSelectedActo] = useState(0);
  const [selectedVariante, setSelectedVarainte] = useState(0);
  const [selectedOpcion, setSelectedOpcion] = useState(0);
  const [selectedIdVariante, setSelectedIdVariante] = useState(0);

  // Activar y desactivar boton de regreso
  const [showButton, setShowButton] = useState(false);

  // URLS PHP
  const ramasPhp = URLAPI + "lista_ramas.php";
  const getActosPhp = URLAPI + "lista_actos.php";
  const getVariantsPhp = URLAPI + "lista_variantes.php";
  const getOptions = URLAPI + "lista_opciones.php";
  const getTaxes = URLAPI + "lista_impuestos.php";

    //Variable de respaldo -------------------------------------------------------------
    // ---------------------------------------------------------------------------------
  
      const [impuestosGuardadosRes, setImpuestosGuardadosRes] = useState({});
    //Variable de estado para almacenar los honorarios que ya estaban guardados
    const [honorariosGuardadosRes, setHonorariosGuardadosRes] = useState({});
    //Variable de estado para almacenar el iva que ya estaba guardado
    const [ivaGuardadoRes, setIvaGuardadoRes] = useState("");
  
    // ---------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------
  



  // Validaciones Selects
  const [isSelectActo, setIsSelectActo] = useState(false);
  const [isSelectVariante, setIsSelectVariante] = useState(false);
  const [isSelectOpcion, setIsSelecOpcion] = useState(false);

  //Variables para el checklist
  const [checkListOpen, setCheckListOpen] = useState(false);

  const [resImpuesto, setResImpuesto] = useState(undefined);

  //Guardamos el nombre del acto juridico y los documentos necesarios
  const [name_legalact, setName_LegalAct] = useState("");
  const [documento, setDocumento] = useState([]);

  //Parte del formulario ----------------------------------------------------------------------------------

  // States
  const [inputNumeroInmuebles, setInputNumeroInmuebles] = useState("");
  const [baseValor, setBaseValor] = useState(0);
  const [msg, setMsg] = useState("");
  const [inmueble, setInmueble] = useState([
    // {
    //   valorOp: 0,
    //   valorComercial: 0,
    //   valorCatastral: 0,
    // },
  ]);

  const [resnumber, setResnumber] = useState(0);
  const [resPonse, setResPonse] = useState(undefined);

  const [showIframe, setShowIframe] = useState(false);
  const [showIframe2, setShowIframe2] = useState(false);
  const [showModal, setShowModal] = useState(false);


  
const detectChanges = async () => {

  console.log("========== detectChanges ==========");

  console.log("RESPALDO no inmuebles:", respaldoNo_Inmuebles);
  console.log("ACTUAL no inmuebles:", inputNumeroInmuebles);

  console.log("RESPALDO inmueble:", respaldoArray_Inmuebles);
  console.log("ACTUAL inmueble:", inmueble);

  const respaldoVacio =
    respaldoNo_Inmuebles === 0 &&
    respaldoArray_Inmuebles.length === 0;

  const cambioNumero =
    respaldoNo_Inmuebles !== inputNumeroInmuebles;

  const cambioLongitud =
    respaldoArray_Inmuebles.length !== inmueble.length;

  const cambioContenido =
    JSON.stringify(respaldoArray_Inmuebles) !==
    JSON.stringify(inmueble);

  console.log("¿Respaldo vacío?:", respaldoVacio);
  console.log("¿Cambió número?:", cambioNumero);
  console.log("¿Cambió longitud?:", cambioLongitud);
  console.log("¿Cambió contenido?:", cambioContenido);

  const hayCambios =
    !respaldoVacio &&
    (
      cambioNumero ||
      cambioLongitud ||
      cambioContenido
    );

  console.log("¿HAY CAMBIOS?:", hayCambios);

  if (hayCambios) {

    console.log(">>> TRUE: mostrando alerta");

    setIsAlert5(true);
    setDetectarCambios(true);

  } else {

    console.log(">>> FALSE: ejecutando handleSave");

    setIsAlert5(false);
    setDetectarCambios(false);
    handleSave();
  }

  console.log("GUARDANDO NUEVO RESPALDO...");
  console.log("Nuevo respaldo número:", inputNumeroInmuebles);
  console.log("Nuevo respaldo inmueble:", inmueble);

  setRespaldoNo_Inmuebles(inputNumeroInmuebles);
  setRespaldoArray_Inmuebles(
    JSON.parse(JSON.stringify(inmueble))
  );
};

  //Función del checklist

  const selectData = useMemo(
    () => [
      { text: "Colima - VdeA", value: 1 },
      { text: "Manzanillo", value: 2 },
      { text: "Rto Municipios", value: 3 },
      { text: "Foráneos", value: 4 },
    ],
    [],
  );

  const quotationRef = useRef(null);

  const saveCot = URLAPI + "guarda_expediente.php";
  //Creamos una función para que guarde toda la información del expediente
  const save_information = async () => {
    // Separar texto por , y convertirlo en array
    const impuestosNew = document
      .getElementById("hcuales_impuestos")
      .value.split(",");
    // Agregar txt_impuesto
    const addTextImp = impuestosNew.map((item) => `txt_impuesto${item}`);
    // Buscar inputs
    const impComplete = addTextImp.map((item) => {
      return {
        [item]: parseFloat(
          document.getElementById(`${item}`).value.replace(",", ""),
        ),
      };
    });

    // Honorarios (montos)
    // Separar texto por , y convertirlo en array
    const honorariosNew = document
      .getElementById("hcuales_honorarios")
      .value.split(",");
    // Agregar txt_honorario
    const addTextHonor = honorariosNew.map((item) => `txt_honorario${item}`);
    // Buscar inputs
    const honorariosList = addTextHonor.map((item) => {
      return {
        [item]: parseFloat(
          document.getElementById(`${item}`).value.replace(",", ""),
        ),
      };
    });

    // Honorarios (seleccionados)
    const honorariosSel = addTextHonor.map((item, index) => {
      return {
        [item]: parseInt(
          document.getElementById(`chkhonorario_${index + 1}`).value,
        ),
      };
    });

    //Le añadimos las fechas a los archivos según corresponda
    const archiveWithDates = archive.map((fileName) => {
      if (typeof fileName === "object") {
        return {
          nombre: fileName.nombre,
          fecha: fechas[fileName.nombre] || null,
        };
      } else {
        return {
          nombre: fileName,
          fecha: fechas[fileName] || null,
        };
      }
    });

     //console.log("archivos fecha", archiveWithDates);

    //console.log("archivos con fechas", archiveWithDates);

    if (otorgante.length == 0) {
      var data = {};

      if (resImpuesto == 0) {
        if (isSelectVariante) {
          data = {
            id_user: id_user,
            id_acto: selectedActo,
            id_variante: selectedIdVariante,
            id_option: selectedOpcion,
            inmueble: [],
            base_valor: [],
            otorgantes: 0,
            adquirientes: adquiriente,
            archivos: archiveWithDates,
            iva: parseInt(document.getElementById("chkiva").value),
            impuestos: impComplete,
            honorarios: honorariosList,
            honorariosSel: honorariosSel,
            hcuantos_honorarios: document.getElementById("hcuantos_honorarios")
              .value,
            hcuales_honorarios:
              document.getElementById("hcuales_honorarios").value,
            requisitos: documentoArray, // Añadimos los requisitos del acto jurídico
          };
        } else {
          data = {
            id_user: id_user,
            id_acto: selectedActo,
            id_variante: 0,
            id_option: 0,
            inmueble: [],
            base_valor: [],
            otorgantes: 0,
            adquirientes: adquiriente,
            archivos: archiveWithDates,
            iva: parseInt(document.getElementById("chkiva").value),
            impuestos: impComplete,
            honorarios: honorariosList,
            honorariosSel: honorariosSel,
            hcuantos_honorarios: document.getElementById("hcuantos_honorarios")
              .value,
            hcuales_honorarios:
              document.getElementById("hcuales_honorarios").value,
            requisitos: documentoArray, // Añadimos los requisitos del acto jurídico
          };
        }
      } else {
        if ((isSelectOpcion && isSelectVariante) || isSelectVariante) {
          data = {
            id_user: id_user,
            id_acto: selectedActo,
            id_variante: selectedIdVariante,
            id_option: selectedOpcion,
            inmueble: inmueble,
            base_valor: baseValor,
            otorgantes: 0,
            adquirientes: adquiriente,
            archivos: archiveWithDates,
            iva: parseInt(document.getElementById("chkiva").value),
            impuestos: impComplete,
            honorarios: honorariosList,
            honorariosSel: honorariosSel,
            hcuantos_honorarios: document.getElementById("hcuantos_honorarios")
              .value,
            hcuales_honorarios:
              document.getElementById("hcuales_honorarios").value,
            requisitos: documentoArray, // Añadimos los requisitos del acto jurídico
          };
        } else {
          data = {
            id_user: id_user,
            id_acto: selectedActo,
            id_variante: 0,
            id_option: 0,
            inmueble: inmueble,
            base_valor: baseValor,
            otorgantes: 0,
            adquirientes: adquiriente,
            archivos: archiveWithDates,
            iva: parseInt(document.getElementById("chkiva").value),
            impuestos: impComplete,
            honorarios: honorariosList,
            honorariosSel: honorariosSel,
            hcuantos_honorarios: document.getElementById("hcuantos_honorarios")
              .value,
            hcuales_honorarios:
              document.getElementById("hcuales_honorarios").value,
            requisitos: documentoArray, // Añadimos los requisitos del acto jurídico
          };
        }
      }
    } else if (adquiriente.length == 0) {
      var data = {};

      if (resImpuesto == 0) {
        if (isSelectVariante) {
          data = {
            id_user: id_user,
            id_acto: selectedActo,
            id_variante: selectedIdVariante,
            id_option: selectedOpcion,
            inmueble: [],
            base_valor: [],
            otorgantes: otorgante,
            adquirientes: 0,
            archivos: archiveWithDates,
            iva: parseInt(document.getElementById("chkiva").value),
            impuestos: impComplete,
            honorarios: honorariosList,
            honorariosSel: honorariosSel,
            hcuantos_honorarios: document.getElementById("hcuantos_honorarios")
              .value,
            hcuales_honorarios:
              document.getElementById("hcuales_honorarios").value,
            requisitos: documentoArray, // Añadimos los requisitos del acto jurídico
          };
        } else {
          data = {
            id_user: id_user,
            id_acto: selectedActo,
            id_variante: 0,
            id_option: 0,
            inmueble: [],
            base_valor: [],
            otorgantes: otorgante,
            adquirientes: 0,
            archivos: archiveWithDates,
            iva: parseInt(document.getElementById("chkiva").value),
            impuestos: impComplete,
            honorarios: honorariosList,
            honorariosSel: honorariosSel,
            hcuantos_honorarios: document.getElementById("hcuantos_honorarios")
              .value,
            hcuales_honorarios:
              document.getElementById("hcuales_honorarios").value,
            requisitos: documentoArray, // Añadimos los requisitos del acto jurídico
          };
        }
      } else {
        if ((isSelectOpcion && isSelectVariante) || isSelectVariante) {
          data = {
            id_user: id_user,
            id_acto: selectedActo,
            id_variante: selectedIdVariante,
            id_option: selectedOpcion,
            inmueble: inmueble,
            base_valor: baseValor,
            otorgantes: otorgante,
            adquirientes: 0,
            archivos: archiveWithDates,
            iva: parseInt(document.getElementById("chkiva").value),
            impuestos: impComplete,
            honorarios: honorariosList,
            honorariosSel: honorariosSel,
            hcuantos_honorarios: document.getElementById("hcuantos_honorarios")
              .value,
            hcuales_honorarios:
              document.getElementById("hcuales_honorarios").value,
            requisitos: documentoArray, // Añadimos los requisitos del acto jurídico
          };
        } else {
          data = {
            id_user: id_user,
            id_acto: selectedActo,
            id_variante: 0,
            id_option: 0,
            inmueble: inmueble,
            base_valor: baseValor,
            otorgantes: otorgante,
            adquirientes: 0,
            archivos: archiveWithDates,
            iva: parseInt(document.getElementById("chkiva").value),
            impuestos: impComplete,
            honorarios: honorariosList,
            honorariosSel: honorariosSel,
            hcuantos_honorarios: document.getElementById("hcuantos_honorarios")
              .value,
            hcuales_honorarios:
              document.getElementById("hcuales_honorarios").value,
            requisitos: documentoArray, // Añadimos los requisitos del acto jurídico
          };
        }
      }
    } else {
      var data = {};

      if (resImpuesto == 0) {
        if (isSelectVariante) {
          data = {
            id_user: id_user,
            id_acto: selectedActo,
            id_variante: selectedIdVariante,
            id_option: selectedOpcion,
            inmueble: [],
            base_valor: [],
            otorgantes: otorgante,
            adquirientes: adquiriente,
            archivos: archiveWithDates,
            iva: parseInt(document.getElementById("chkiva").value),
            impuestos: impComplete,
            honorarios: honorariosList,
            honorariosSel: honorariosSel,
            hcuantos_honorarios: document.getElementById("hcuantos_honorarios")
              .value,
            hcuales_honorarios:
              document.getElementById("hcuales_honorarios").value,
            requisitos: documentoArray, // Añadimos los requisitos del acto jurídico
          };
        } else {
          data = {
            id_user: id_user,
            id_acto: selectedActo,
            id_variante: 0,
            id_option: 0,
            inmueble: [],
            base_valor: [],
            otorgantes: otorgante,
            adquirientes: adquiriente,
            archivos: archiveWithDates,
            iva: parseInt(document.getElementById("chkiva").value),
            impuestos: impComplete,
            honorarios: honorariosList,
            honorariosSel: honorariosSel,
            hcuantos_honorarios: document.getElementById("hcuantos_honorarios")
              .value,
            hcuales_honorarios:
              document.getElementById("hcuales_honorarios").value,
            requisitos: documentoArray, // Añadimos los requisitos del acto jurídico
          };
        }
      } else {
        if ((isSelectOpcion && isSelectVariante) || isSelectVariante) {
          data = {
            id_user: id_user,
            id_acto: selectedActo,
            id_variante: selectedIdVariante,
            id_option: selectedOpcion,
            inmueble: inmueble,
            base_valor: baseValor,
            otorgantes: otorgante,
            adquirientes: adquiriente,
            archivos: archiveWithDates,
            iva: parseInt(document.getElementById("chkiva").value),
            impuestos: impComplete,
            honorarios: honorariosList,
            honorariosSel: honorariosSel,
            hcuantos_honorarios: document.getElementById("hcuantos_honorarios")
              .value,
            hcuales_honorarios:
              document.getElementById("hcuales_honorarios").value,
            requisitos: documentoArray, // Añadimos los requisitos del acto jurídico
          };
        } else {
          data = {
            id_user: id_user,
            id_acto: selectedActo,
            id_variante: 0,
            id_option: 0,
            inmueble: inmueble,
            base_valor: baseValor,
            otorgantes: otorgante,
            adquirientes: adquiriente,
            archivos: archiveWithDates,
            iva: parseInt(document.getElementById("chkiva").value),
            impuestos: impComplete,
            honorarios: honorariosList,
            honorariosSel: honorariosSel,
            hcuantos_honorarios: document.getElementById("hcuantos_honorarios")
              .value,
            hcuales_honorarios:
              document.getElementById("hcuales_honorarios").value,
            requisitos: documentoArray, // Añadimos los requisitos del acto jurídico
          };
        }
      }
    }

       console.log("datos que se van a guardar", data);

     try {
      const res = await axios.post(saveCot, data);
      setResnumber(res.data);
      //console.log(res);

      if (res.data) {
        //Activamos como true una variable de estado para que active un alert de que se logro guardar correctamente
        setDateSearch(true);
        //Guardamos el folio en otra variable de tipo string
        setFol(res.data);
      
      }
    } catch (error) {
      console.error("Error en enviar los datos", error);
    }
  };


  useEffect(() => {
    //console.log("hay cambios")
    const container = quotationRef.current;
    if (!container) return;
  
    const handleChange = () => {
      const impuestosInput = container.querySelector("#hcuales_impuestos");
      const honorariosInput = container.querySelector("#hcuales_honorarios");
      const ivaInput = container.querySelector("#chkiva");
  
        if (impuestosInput) {
      console.log("Nuevos impuestos:", impuestosInput.value);
    }
  
    if (honorariosInput) {
      console.log("Nuevos honorarios:", honorariosInput.value);
    }
  
    if (ivaInput) {
      console.log("Nuevo IVA:", ivaInput.value);
    }
  
            // IMPUESTOS
    if (impuestosInput) {
      const impuestosNew = impuestosInput.value.split(",");
  
      const impuestosObj = {};
  
      impuestosNew.forEach((item) => {
        const input = container.querySelector(`#txt_impuesto${item}`);
  
        if (input) {
          impuestosObj[item] = input.value;
        }
      });
  
      console.log("Nuevos impuestos:", impuestosObj);
      setImpuestosGuardadosRes(impuestosObj);
    }
  
    // HONORARIOS
    if (honorariosInput) {
      const honorariosNew = honorariosInput.value.split(",");
  
      const honorariosObj = {};
  
      honorariosNew.forEach((item) => {
        const input = container.querySelector(`#txt_honorario${item}`);
  
        if (input) {
          honorariosObj[item] = input.value;
        }
      });
  
      console.log("Nuevos honorarios:", honorariosObj);
      setHonorariosGuardadosRes(honorariosObj);
    }
  
      if (ivaInput) {
        setIvaGuardadoRes(parseInt(ivaInput.value));
      }
    };
  
    container.addEventListener("change", handleChange);
  
    return () => {
      container.removeEventListener("change", handleChange);
    };
  }, [resPonse]);

  /* const archiveWithDates = archive.map((fileName) => {
        if (typeof fileName === "object") {
          return {
            nombre: fileName.nombre,
            fecha:fechas[fileName.nombre] || null,

          }
        } else {
      return {
        nombre: fileName,
        fecha: fechas[fileName] || null,
      };
    }
    });

    console.log("archivos fecha", archiveWithDates)*/

  // Funcionalidad de los inputs por cada inmueble y su array
  const handleInputNoIn = (e) => {
    let input = "";

    if (typeof e === "string") {
      //setIsFirstLoad(firsload);
      input = e;
    } else {
      input = e?.target?.value ?? "";
    }
    if (/^\d{0,2}$/.test(input)) {
      setInputNumeroInmuebles(input);
      //console.log("input", input);
      //Si el elemento que se respaldo para cuando se le dio atras es mayor a lo que ha solicitado el usuario en el input, se eliminara lo necesario
      if (parseInt(input) < inmuebleBackup.length) {
        setInmuebleBackup((prev) => prev.slice(0, parseInt(input)));
      }
      //inmuebleBackup
    }

    setInmueble((prevIn) => {
      const nuevosInmuebles = [...prevIn];

      for (let i = nuevosInmuebles.length; i < input; i++) {
        nuevosInmuebles.push({
          valorOp: "",
          valorComercial: "",
          valorCatastral: "",
        });
      }

      nuevosInmuebles.splice(input);

      return nuevosInmuebles;
    });
  };

  //Función que determina si el archivo expiro o no
  const file_date = (vigencia, fecha_carga) => {
    const vigencia_number = Number(vigencia);
    // Fecha actual
    const fecha_actual = new Date();

    //console.log("Fecha actual:", fecha_actual);

    // Convertimos fecha de carga a Date
    const partes = fecha_carga.split("-");
    const fechaObj = new Date(partes[0], partes[1] - 1, partes[2]);

    //console.log("Fecha de carga del archivo:", fechaObj);

    // Sumamos vigencia en meses
    fechaObj.setMonth(fechaObj.getMonth() + vigencia_number);

    // console.log("Vigencia en meses:", vigencia_number);

    // console.log("Fecha límite del archivo:", fechaObj);

    // Comparación
    return fechaObj < fecha_actual;
  };

  // hanndleChange de campos del inmueble
  const handleChangeOperacion = (e, index) => {
    const nuevoInmueble = [...inmueble];

    // const inputValue = e?.target.value;

    const inputValue = typeof e === "string" ? e : (e?.target?.value ?? "");

    //Si no se logra detecta algun valor, entonces sera un string vacio, esto para que no lance el error de que se intento parsear Nan
    nuevoInmueble[index].valorOp =
      inputValue === "" ? "" : parseFloat(inputValue);

    /*if (inmuebleBackup2.length > 0 && inmueble[index].valorOp !== inmuebleBackup2[index].valorOp) { //Estas parte se encargaban de verificar si hubo algun cambio verificando el respaldo unico
      setDetectarCambios(true);
      setMsg("Se detectaron cambios en los valores de inmueble")
    } else {
      setDetectarCambios(false);
      //console.log("cero cambios", inmuebleBackup2[index]?.valorOp, "no hay cambio", inmueble[index]?.valorOp)
    }*/
    setInmueble(nuevoInmueble);
  };
  const handleChangeComercial = (e, index) => {
    const nuevoInmueble = [...inmueble];

    const inputValue = typeof e === "string" ? e : (e?.target?.value ?? "");
    //Si no se logra detecta algun valor, entonces sera un string vacio, esto para que no lance el error de que se intento parsear Nan

    nuevoInmueble[index].valorComercial =
      inputValue === "" ? "" : parseFloat(inputValue);

    /*if (inmuebleBackup2.length > 0 && inmueble[index].valorComercial !== inmuebleBackup2[index].valorComercial) {
      setDetectarCambios(true);
      setMsg("Se detectaron cambios en los valores de inmueble")
    } else {
      setDetectarCambios(false);
      setMsg("Se detectaron cambios en los valores de inmueble")
    }*/
    setInmueble(nuevoInmueble);
  };
  const handleChangeCatastral = (e, index) => {
    const nuevoInmueble = [...inmueble];

    const inputValue = typeof e === "string" ? e : (e?.target?.value ?? "");
    //Si no se logra detecta algun valor, entonces sera un string vacio, esto para que no lance el error de que se intento parsear Nan
    nuevoInmueble[index].valorCatastral =
      inputValue === "" ? "" : parseFloat(inputValue);

    /* if (inmuebleBackup2.length > 0 && inmueble[index].valorCatastral !== inmuebleBackup2[index].valorCatastral) {
      setDetectarCambios(true);
    } else {
      setDetectarCambios(false);
    }*/
    setInmueble(nuevoInmueble);
  };
  useEffect(() => {
    //console.log("inmueble backup 2 actualizado", detectarCambios);
  }, [detectarCambios]);

  // Configuración para que no se pueda ingresar ningun texto al imput de selecciona tu fecha de nacimiento
  const CustomDateInput = forwardRef(({ value, onClick }, ref) => {
    //console.log("Rendering CustomDateInput");
    const internalRef = useRef(null);

    useImperativeHandle(ref, () => ({
      focus: () => {
        //console.log("Focusing input");
        internalRef.current?.focus();
      },
      highlight: () => {
        //console.log("Highlighting input");
        if (!internalRef.current) return;
        internalRef.current.classList.add("highlight-input");
        setTimeout(() => {
          internalRef.current.classList.remove("highlight-input");
        }, 2000);
      },
    }));

    return (
      <div className="position-relative w-100">
        <input
          disabled
          type="text"
          ref={internalRef}
          value={value}
          readOnly
          className="form-control pe-5"
          onClick={onClick}
          placeholder="Selecciona la fecha de firma"
        />
        <button
          type="button"
          onClick={onClick}
          className="btn btn-warning position-absolute top-50 end-0 translate-middle-y me-1 d-flex align-items-center gap-1"
          style={{ borderRadius: "8px", fontWeight: "bold" }}
        >
          <i className="fas fa-caret-down"></i>
        </button>
      </div>
    );
  });

  //Creamos una funcion para devolver otra vez el div del formulario que se oculta cuando se ingresan los datos
  const devolver = () => {
    //console.log("se guardo", inmuebleBackup2);
    //Verificamos que se haya guardado los respaldos
    setDetectarCambios(true);
    //console.log("Variante Backcup", varianteBackup);
    //console.log("Rama Backup", ramaBackup);
    //console.log("Acto Backup", actoBackup);
    //console.log("Opcion Backup", opcionBackup);
    setInmueble(inmuebleBackup); // restauramos copia
    setIsAlert(false);
    setIsAlert3(false);
    //console.log("se recupero el inmueble", inmuebleBackup);
    //console.log("inmueble recuperado", );
    setOcultarFormulario(false);
    setShowIframe(false);
  };

  // Componente del item Inmueble (se repite cada que interactua el input del numero de muebles)
  const renderComponents = () => {
    //console.log("renderizando componentes de inmueble");
    const componentes = [];
    for (let index = 0; index < inputNumeroInmuebles; index++) {
      componentes.push(
        <MDBRow className="mt-1" key={index}>
          <MDBCol>
            <p>Inmueble {index + 1}</p>
          </MDBCol>
          <MDBCol>
            <MDBInput
              label="Valor operación"
              onChange={(e) => handleChangeOperacion(e, index)}
              value={
                inmuebleBackup?.length > 0
                  ? inmuebleBackup[index]?.valorOp
                  : inmueble[index]?.valorOp
              }
              onWheel={(e) => e.target.blur()}
              type="number"
              min={0}
            />
          </MDBCol>
          <MDBCol>
            <MDBInput
              label="Valor comercial"
              onChange={(e) => handleChangeComercial(e, index)}
              value={
                inmuebleBackup?.length > 0
                  ? inmuebleBackup[index]?.valorComercial
                  : inmueble[index]?.valorComercial
              }
              onWheel={(e) => e.target.blur()}
              type="number"
              min={0}
            />
          </MDBCol>
          <MDBCol>
            <MDBInput
              label="Valor catastral"
              onChange={(e) => handleChangeCatastral(e, index)}
              value={
                inmuebleBackup?.length > 0
                  ? inmuebleBackup[index]?.valorCatastral
                  : inmueble[index]?.valorCatastral
              }
              onWheel={(e) => e.target.blur()}
              type="number"
              min={0}
            />
          </MDBCol>
        </MDBRow>,
      );
    }
    return componentes;
  };

  //   handle de Base valor del calculo
  const handleBaseValorSelect = (e) => {
    //Bool para que los elementos de guardar archivos, agregar otorgantes etc, aparezcan
    setBoolElemento(true);
    const inputSelect = e.target.value;
    setBaseValor(parseInt(inputSelect));
  };

  //   Verificar si algun campo del inmueble esta vacio, si es que existe
  const basicIsNotEmpty = () => {
    if (
      (inmueble.length !== 0 && baseValor !== 0) ||
      (inmueble >= 0 && selectedIdVariante)
    ) {
      //console.log("true de basic")
      return true;
    } else {
      //console.log("false de basic")
      return false;
    }
  };

  // validacion de campos de los inmuebles
  const inmuebleIsNotEmpty = (inmuebles) => {
    const array = inmuebles.map((item) => {
      if (
        item.valorOp === 0 ||
        item.valorOp === "" ||
        item.valorComercial === 0 ||
        item.valorComercial === "" ||
        item.valorCatastral === 0 ||
        item.valorCatastral === ""
      ) {
        // setIsEmptyTaxes(true);
        return false;
      } else {
        return true;
      }
    });
    return array;
  };

  // Validación de campo catastral en caso que sea Manzanillo
  const catastralIsEmpty = (inmuebles) => {
    const array = inmuebles.map((item) => {
      if (item.valorCatastral === 0 && baseValor === 1) {
        return false;
      } else {
        return true;
      }
    });
    return array;
  };

  const archiveSelect = archive.map((fileName) => {
    if (typeof fileName === "object") {
      return {
        nombre: fileName.nombre,
        fecha: fechas[fileName.nombre] || null,
      };
    } else {
      return {
        nombre: fileName,
        fecha: fechas[fileName] || null,
      };
    }
  });

  const archivosSinFecha = archiveSelect.filter((fileName) => !fileName.fecha);

  // console.log("archivos sin fecha", archivosSinFecha);

  const handleSave = async () => {
    // console.log("se presiono guardar");
    //Validación de que no haya archivos sin fecha de vigencia
    if (archivosSinFecha.length > 0) {
      setMsg("Algunos o todos los campos de vigencia están vacíos");
      setIsAlert3(true);

      //focusAndHighlight(archivo_fecharef);
      return;
    }

    const arrayValidacionCampos = inmuebleIsNotEmpty(inmueble);
    const arrayValidacionCatastral = catastralIsEmpty(inmueble);

    if (detectarCambios) {
      if (
        basicIsNotEmpty() &&
        !arrayValidacionCampos.some((el) => !el) &&
        !arrayValidacionCatastral.some((el) => !el) &&
        (isSelectVariante && resImpuesto !== 0
          ? inputNumeroInmuebles != null &&
            inputNumeroInmuebles !== 0 &&
            inputNumeroInmuebles !== ""
          : true) &&
        (isSelectOpcion && resImpuesto !== 0
          ? inputNumeroInmuebles != null &&
            inputNumeroInmuebles !== 0 &&
            inputNumeroInmuebles !== "" &&
            selectedOpcion !== 0
          : true) &&
        (isSelectActo ? selectedActo !== 0 : true) &&
        selectedRama !== 0 &&
        selectedActo !== 0 &&
        (isSelectOpcion ? selectedOpcion !== 0 : true) &&
        (isSelectVariante ? selectedVariante !== 0 : true)
      ) {
        if (
          (adquiriente.length >= 1 && otorgante.length == 0) ||
          (adquiriente.length == 0 && otorgante.length >= 1) ||
          (adquiriente.length >= 1 && otorgante.length >= 1)
        ) {
         // setIsAlert5(true);
        } else {
          setIsAlert3(true);
          setMsg("Agrega al menos un adquiriente o un otorgante");
        }
      } else {
        setIsAlert3(true);
        setMsg("Faltan campos por llenar en el acto jurídico");
      }
    } else {
      if (
        basicIsNotEmpty() &&
        !arrayValidacionCampos.some((el) => !el) &&
        !arrayValidacionCatastral.some((el) => !el) &&
        (isSelectVariante && resImpuesto !== 0
          ? inputNumeroInmuebles != null &&
            inputNumeroInmuebles !== 0 &&
            inputNumeroInmuebles !== ""
          : true) &&
        (isSelectOpcion && resImpuesto !== 0
          ? inputNumeroInmuebles != null &&
            inputNumeroInmuebles !== 0 &&
            inputNumeroInmuebles !== "" &&
            selectedOpcion !== 0
          : true) &&
        (isSelectActo ? selectedActo !== 0 : true) &&
        selectedRama !== 0 &&
        selectedActo !== 0 &&
        (isSelectOpcion ? selectedOpcion !== 0 : true) &&
        (isSelectVariante ? selectedVariante !== 0 : true)
      ) {
        if (
          (adquiriente.length >= 1 && otorgante.length == 0) ||
          (adquiriente.length == 0 && otorgante.length >= 1) ||
          (adquiriente.length >= 1 && otorgante.length >= 1)
        ) {
          handleOnClickSave();
        } else {
          setIsAlert3(true);
          setMsg("Agrega al menos un adquiriente o un otorgante");
        }
      } else {
        setIsAlert3(true);
        setMsg("Faltan campos por llenar en el acto jurídico");
      }
    }
  };

  // Si hubo cambios, mostramos alerta

  //Agregamos validaciones antes de guardar

  //console.log("datos que se van a mandar", data);

  //console.log("validacion1", arrayValidacionCampos)
  //console.log("validacion2", arrayValidacionCatastral)

  /*console.log(
        "validacion 1",
        arrayValidacionCampos,
        "validacion2",
        arrayValidacionCatastral,
        "validacion3",
        basicIsNotEmpty()
      );*/

  /*//Variante
  useEffect(() => {
    //console.log("inmueble backup 2 actualizado", inmuebleBackup2);
    console.log("variante backup actualizado", selectedVariante);
  }, [selectedVariante]);

  //Rama
  useEffect(() => {
    //console.log("inmueble backup 2 actualizado", inmuebleBackup2);
    console.log("rama backup actualizado", selectedRama);
  }, [selectedRama]);

  //Acto
  useEffect(() => {
    //console.log("inmueble backup 2 actualizado", inmuebleBackup2);
    console.log("acto backup actualizado", selectedActo);
  }, [selectedActo]);

  //Opcion
  useEffect(() => {
    //console.log("inmueble backup 2 actualizado", inmuebleBackup2);
    console.log("opcion backup actualizado", selectedOpcion);
  }, [selectedOpcion]);

*/

  //Mandar al backend
  const handleOnClickSave = async () => {
    //Verificamos si habia enlistados de algun hecho legal guardado en zustand

    const encontrado = documentosGuardados.find(
      (doc) => doc[1] === name_legalact,
    );

    if (encontrado) {
      //console.log("Encontrado con zustand:", encontrado);
      setDocumentoArray(encontrado);
    } else {
      //console.log("hecho legal", name_legalact);
      //console.log("documentos guardados", documentosGuardados);

      // Si no habia nada guardado, dejamos un array por default (todo falso)

      const array_document = documento.map((doc, index) => ({
        activar: 0,
        seleccionado: 0,
        documento: doc,
      }));
      //Creamos otra parte del array para agregarle el hecho legal
      const array_with_legalact = [array_document, name_legalact];

      //console.log("encontrado normal", array_with_legalact);

      setDocumentoArray(array_with_legalact);
    }

    let data = {};
    //Detectamos si hubo cambios, respecto a si el usuario le dio atras anteriormente
    if (resImpuesto == 0) {
      if (isSelectVariante) {
        data = {
          id_user: id_user,
          nombre_adquiriente: adquiriente,
          nombre_otorgante: otorgante,
          id_rama: selectedRama,
          id_acto: selectedActo,
          id_variante: selectedIdVariante,
          id_opcion: selectedOpcion,
          inmueble: [],
          base_valor: 0,
        };
      } else {
        data = {
          id_user: id_user,
          nombre_adquiriente: adquiriente,
          nombre_otorgante: otorgante,
          id_rama: selectedRama,
          id_acto: 0,
          id_variante: 0,
          id_opcion: 0,
          inmueble: [],
          base_valor: 0,
        };
      }
    } else {
      //console.log("se guardo el respaldo", inmuebleBackup);

      if ((isSelectOpcion && isSelectVariante) || isSelectVariante) {
        data = {
          id_user: id_user,
          nombre_adquiriente: adquiriente,
          nombre_otorgante: otorgante,
          id_rama: selectedRama,
          id_acto: selectedActo,
          id_variante: selectedIdVariante,
          id_opcion: selectedOpcion,
          inmueble: inmueble,
          base_valor: baseValor,
        };
      } else {
        data = {
          id_user: id_user,
          nombre_adquiriente: adquiriente,
          nombre_otorgante: otorgante,
          id_rama: selectedRama,
          id_acto: selectedActo,
          id_variante: 0,
          id_opcion: 0,
          inmueble: inmueble,
          base_valor: baseValor,
        };
      }
    }

    // console.log("Datos validados: Mandando datos");
    setOcultarFormulario(true);
    try {
      setInmuebleBackup2(JSON.parse(JSON.stringify(inmueble))); // guardamos el estado actual antes de comparar con una referencia unica para que no este unida directamente y se pueda hacer la comparativa si es que hubo algun cambio despues, esto para los valores de inmuebles

      //Hacemos lo mismo con variante, rama, acto y opcion ------------------------------------------------------------------------------------------
      setVarianteBackup(JSON.parse(JSON.stringify(selectedVariante)));
      setRamaBackup(JSON.parse(JSON.stringify(selectedRama)));
      setActoBackup(JSON.parse(JSON.stringify(selectedActo)));
      setOpcionBackup(JSON.parse(JSON.stringify(selectedOpcion)));
      // --------------------------------------------------------------------------------------------------------------------------------------------------------
      const res = await axios.post(presupuesto, data);
      //console.log("respuesta html", res);
      setResPonse(res.data);
      setShowIframe(true);
      setMsg("");
      setInmuebleBackup(inmueble); // guardamos copia antes de ocultar

      setTimeout(() => {
        window.scroll({
          top: document.body.offsetHeight,
          left: 0,
          behavior: "smooth",
        });
      }, 500);
    } catch (error) {
      console.log("se tuvo error: ", error);
    }

    /*
    
    // Impuestos
    // Separar texto por , y convertirlo en array
    const impuestosNew = document
      .getElementById("hcuales_impuestos")
      .value.split(",");
    // Agregar txt_impuesto
    const addTextImp = impuestosNew.map((item) => `txt_impuesto${item}`);
    // Buscar inputs
    const impComplete = addTextImp.map((item) => {
      return {
        [item]: parseFloat(
          document.getElementById(`${item}`).value.replace(",", "")
        ),
      };
    });

    // Honorarios (montos)
    // Separar texto por , y convertirlo en array
    const honorariosNew = document
      .getElementById("hcuales_honorarios")
      .value.split(",");
    // Agregar txt_honorario
    const addTextHonor = honorariosNew.map((item) => `txt_honorario${item}`);
    // Buscar inputs
    const honorariosList = addTextHonor.map((item) => {
      return {
        [item]: parseFloat(
          document.getElementById(`${item}`).value.replace(",", "")
        ),
      };
    });

    // Honorarios (seleccionados)
    const honorariosSel = addTextHonor.map((item, index) => {
      return {
        [item]: parseInt(
          document.getElementById(`chkhonorario_${index + 1}`).value
        ),
      };
    });

    const data = {
      id_user: id_user,
      nombre_titular: nameTitular,
      id_acto: selectedActo,
      id_variante: selectedIdVariante,
      base_valor: baseValor,
      iva: parseInt(document.getElementById("chkiva").value),
      inmueble: inmueble,
      impuestos: impComplete,
      honorarios: honorariosList,
      honorariosSel: honorariosSel,
      hcuantos_honorarios: document.getElementById("hcuantos_honorarios").value,
      hcuales_honorarios: document.getElementById("hcuales_honorarios").value,
    };
    try {
      const res = await axios.post(saveCot, data);
      setResnumber(res.data);
      if (res.data > 0) {
        setShowModal(true);
      } else {
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error en enviar los datos", error);
    } */
  };

  const handlePrint = () => {
    window.open(
      URLAPI + `pdf_cotizacion.php?cotizacion=${resnumber}`,
      "_blank",
    );
    // printWindow.close()
    // printWindow.print()
    setShowModal(false);
    window.location.reload();
  };

  //Parte del formulario ----------------------------------------------------------------------------------

  // OnChanges
  const handleOnChangeInputTitular = (e) => {
    const input = e.target.value;
    setNameTitular(input);
  };

  // Ramas
  useEffect(() => {
    const getRamas = async () => {
      try {
        const res = await axios.get(ramasPhp);
        setListRamas(res.data);
      } catch (error) {
        console.error("Error al obtener Ramas", error);
      }
    };
    getRamas();
  }, []);

  useEffect(() => {
    if (resImpuesto !== undefined) {
      setShowButton(false);
    } else {
      setShowButton(true);
    }
  }, [resImpuesto]);

  const handleChangeSelectRama = async (e) => {
    setSelectedActo(0);
    setSelectedIdVariante(0);
    setSelectedVarainte(0);
    setSelectedOpcion(0);
    setIsSelectVariante(false);
    setIsSelecOpcion(false);
    setResImpuesto(undefined);
    if (typeof e === "string") {
      var id_rama = parseInt(e);
    } else {
      var id_rama = parseInt(e.target.value);
    }
    setSelectedRama(id_rama);
    if (id_rama !== 0) {
      setIsSelectActo(true);
      try {
        const res = await axios.post(getActosPhp, { data: id_rama });
        setListActos(res.data);
      } catch (error) {
        console.error("Error al obtener actos juridicos", error);
      }
    } else {
      setIsSelectActo(false);
      setIsSelectVariante(false);
    }
  };

  // Actos Juridicos
  const handleChangeSeletActos = async (e) => {
    if (typeof e === "string") {
      var id_acto = parseInt(e);
    } else {
      var id_acto = parseInt(e.target.value);
    }
    setSelectedIdVariante(0);
    setSelectedOpcion(0);
    setSelectedVarainte(0);
    setIsSelecOpcion(false);
    setSelectedActo(id_acto);
    setResImpuesto(undefined);

    //const idABuscar = id_acto === 0 ? 1 : parseInt(id_acto);

    const idABuscar = parseInt(id_acto);

    // 2. Usar .find() para obtener el objeto (el Acto) que coincide con ese ID
    const actoEncontrado = listActos.find((acto) => acto.id_acto == idABuscar);

    // 3. Imprimir el objeto encontrado (si se encontró)
    /*console.log("ID a buscar:", idABuscar);
    console.log("Lista de actos:", listActos);
    console.log("Acto encontrado:", actoEncontrado);*/

    //Enviamos el acto encontrado para obtener su nombre y documentos necesarios
    //Si no se encuentra, enviamos 0 para que no haya error en la logica de la palomita
    if (actoEncontrado) {
      setName_LegalAct_verification(actoEncontrado);
    } else {
      setName_LegalAct_verification(0);
    }
    if (id_acto !== 0) {
      setIsSelectVariante(true);
      try {
        const res = await axios.post(getVariantsPhp, { data: id_acto });
        const arrayVariantes = res.data;
        setListVariantes(arrayVariantes);
        // Validaciónes si hay actos variantes
        if (arrayVariantes.length === 0) {
          const data = {
            id_acto: id_acto,
            id_variante: 0,
          };
          const resImp = await axios.post(getTaxes, data);
          setResImpuesto(parseInt(resImp.data));
          setIsSelectVariante(false);
          setIsSelecOpcion(false);
        }
      } catch (error) {
        console.error("Error al obtener variantes", error);
      }
    } else {
      setIsSelectVariante(false);
    }
  };

  useEffect(() => {
    if (showModal) {
      var caracteristicas = "left=150, top=50, width=750, height=440";
      const popup = window.open(
        `${poparchivosURL}?id_user=${id_user}`,
        "",
        caracteristicas,
      );

      const timer = setInterval(async () => {
        if (popup && popup.closed) {
          clearInterval(timer);
          //alert("La ventana esta cerrada");
          try {
            const res = await axios.post(
              `${tempo_archivos}?id_user=${id_user}`,
            );

            //Archivos existentes en el servidor

            const archivosExistentes = res.data;
            //console.log("archivos existentes en servidor", archivosExistentes);
            //Los que ya estaban en el sistema
            const archivos_total = [...archive, ...archivosExistentes];
            //console.log("archivos total", archivos_total);

            const archivossinrepetir = [...new Set(archivos_total)];

            const archivosObj = archivosExistentes.reduce((acc, nombre) => {
              const repeticionFecha = fechas[nombre];
              //console.log("repeticion fecha", repeticionFecha)

              acc[nombre] =
                repeticionFecha != undefined && repeticionFecha != 0
                  ? String(repeticionFecha)
                  : "";
              //console.log("nombre", acc[nombre])
              return acc;
            }, {});

            //console.log("archivosObj", archivosObj);

            const fechas_actualizadas = { ...fechas, ...archivosObj };

            setFechas(fechas_actualizadas);
            //console.log("fechas actualizadas", fechas_actualizadas);

            //console.log("archivos sin repetir", archivossinrepetir);

            //La agregamos campos de vigencia de fechas para que se puedan modificar posteriormente

            // const archivosNuevos = [...archive];// < ---------------------

            //console.log("archivos", archivosNuevos);

            /* archivossinrepetir.forEach((file) => {
              const archivo_repetido = archive.find(
                (item) => item.nombre === file,
              );
              if (!archivo_repetido) {
                archivosNuevos.push(file);
              }
            });
*/
            //console.log(res.data);
            setArchive(archivossinrepetir);

            /* if (res) {
                console.log("Se ha logrado desplegar los archivos")
              }*/
          } catch (error) {
            console.log("Error al subir los archivos", error);
          }
        }
      }, 500);
      setShowModal(false);
      /*const modal = document.querySelector(".modal");
        if (modal && window.bootstrap) {
          const bootstrapModal = new window.bootstrap.Modal(modal);
          bootstrapModal.show();
        }*/
    }
  }, [showModal]);

  const handleOpenModal = async () => {
    try {
      const res = await axios.get(poparchivosURL);
      //setModalHTML(res.data);
      setShowModal(true);
    } catch (error) {
      console.error("Error al cargar el modal:", error);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // console.log("Archivos actuales:", archive);

  const delete_files = async (archivo) => {
    //console.log("Eliminar archivo:", archivo);
    try {
      const res = await axios.post(
        `${borra_archivo}?file_name=${archivo}&id_user=${id_user}`,
      );

      if (res) {
        // Eliminar archivo del array
        /*   archive.forEach((file) => {
          if (typeof archivo === "string") {
            if (archivo === file) {
              setArchive((prev) => prev.filter((f) => f !== archivo));
            }
          } else {
            if (archivo === file.nombre) {
              setArchive((prev) => prev.filter((f) => f.nombre !== archivo));
            }
          }
        });*/

        setArchive((prev) =>
          prev.filter((file) =>
            typeof file === "string"
              ? file !== archivo
              : file.nombre !== archivo,
          ),
        );

        // Eliminar la fecha asociada al archivo
        setFechas((prevFechas) => {
          const newFechas = { ...prevFechas };
          delete newFechas[archivo]; // eliminar usando el nombre del archivo
          return newFechas;
        });

        //console.log(res);
      }
    } catch (error) {
      console.log("No se logró borrar el archivo", error);
    }
  };

  // Variantes
  const handleChangeSelectVariantes = async (e, a) => {
    if (typeof e === "string") {
      var id_variante = parseInt(e);
      var acto = a;
    } else {
      var id_variante = parseInt(e.target.value);
      var acto = selectedActo;
    }
    setSelectedOpcion(0);
    setSelectedVarainte(id_variante);
    setSelectedIdVariante(id_variante);
    setResImpuesto(undefined);
    if (id_variante !== 0) {
      setIsSelecOpcion(true);
      const data = {
        id_acto: acto,
        id_variante: id_variante,
      };
      try {
        const res = await axios.post(getOptions, data);
        //  console.log("impuestos de variantes", res, "data", data);
        const arrayOpciones = res.data;
        setListOpciones(arrayOpciones);
        if (arrayOpciones.length === 0) {
          setIsSelecOpcion(false);
          // Obtener impuestos
          const resImp = await axios.post(getTaxes, data);
          setResImpuesto(parseInt(resImp.data));
        }
      } catch (error) {
        console.error("Error al obtener Opciones", error);
      }
    } else {
      setIsSelecOpcion(false);
    }
  };

  // Opciones
  const handleChangeSelectOpcion = async (e, a) => {
    if (typeof e === "string") {
      // console.log("estring");
      var id_varianteOpcion = parseInt(e);
      var acto = a;
    } else {
      var id_varianteOpcion = parseInt(e.target.value);
      var acto = selectedActo;
    }
    setResImpuesto(undefined);
    if (id_varianteOpcion !== 0) {
      setSelectedIdVariante(id_varianteOpcion);
      // Obtener Impuestos
      const data = {
        id_acto: acto,
        id_variante: id_varianteOpcion,
      };
      const resImp = await axios.post(getTaxes, data);
      setResImpuesto(parseInt(resImp.data));
    }
    setSelectedOpcion(id_varianteOpcion);
  };

  const { adquiriente, setAdquiriente, setBoolAdquiriente, setCerrarModal } =
    useUsuarioStore();
  //Creamos un array donde se guardara los nombres de los otorgantes
  const { otorgante, setOtorgante, setBoolOtorgante } = useUsuarioStore();

  //Abrir modal, se pasa como props
  const [isOpen, setIsOpen] = useState(false);

  //Esta variable de estado se encarga de decidir que información mostrara el modal, ya sea el agregar adquirientes u otorgantes
  const [isAdquiriente, setIsAdquiriente] = useState(false);

  //Abrir el modal
  const abrirModal_Otorgantes = () => {
    //Creamos un indicador para saber a donde se le va a insertar el objeto, ya sea en otorgantes o en adquirientes
    //Esta variable booleana, ayuda a definir si es otorgante o adquiriente a fin de que se establesca el parametro de nombre o razon social en el recuadro de adquirientes o otorgantes según sea el caso
    setBoolOtorgante(true);
    //Esta variable ayuda a abrir el recuadro correspondiente para buscar entre los clientes del catalogo o capturar un cliente nuevo
    setCerrarModal(true);
    //Esta variable booleana, ayuda a definir si es otorgante o adquiriente a fin de que se establesca el parametro de nombre o razon social en el recuadro de adquirientes o otorgantes según sea el caso
    setBoolAdquiriente(false);

    ////Esta variable de estado se encarga de decidir que información mostrara el modal, ya sea el agregar adquirientes u otorgantes
    setIsAdquiriente(false);
  };

  const abrirModal_Adquirientes = () => {
    //Creamos un indicador para saber a donde se le va a insertar el objeto, ya sea en otorgantes o en adquirientes
    //Esta variable booleana, ayuda a definir si es otorgante o adquiriente a fin de que se establesca el parametro de nombre o razon social en el recuadro de adquirientes o otorgantes según sea el caso
    setBoolOtorgante(false);
    //Esta variable ayuda a abrir el recuadro correspondiente para buscar entre los clientes del catalogo o capturar un cliente nuevo
    setCerrarModal(true);
    //Esta variable booleana, ayuda a definir si es otorgante o adquiriente a fin de que se establesca el parametro de nombre o razon social en el recuadro de adquirientes o otorgantes según sea el caso
    setBoolAdquiriente(true);
    //setIsOpen(true);
    ////Esta variable de estado se encarga de decidir que información mostrara el modal, ya sea el agregar adquirientes u otorgantes
    setIsAdquiriente(true);
  };
  //Creamos un useEffect para que el setdocumento se actualice cuando se cambie el selected acto
  useEffect(() => {
    const fetchRequisitos = async () => {
      if (selectedActo !== 0) {
        try {
          const res = await axios.post(requisitos, { id_acto: selectedActo });
          // console.log("res data checklist", res.data);

          setDocumento(res.data[1]);
          setName_LegalAct(res.data[0]);
        } catch (error) {
          console.error("Error al obtener los requisitos:", error);
        }
      }
    };

    //console.log("selectedActo cambiado:", selectedActo);

    fetchRequisitos();
  }, [selectedActo]);

  //Creamos otro useEffect para cuando se cambie el setDocumentoE, se cree un array de cada requisito, añadiendo campos como si esta activdado o no, o si esta seleccionado
  // Creamos un useEffect para cuando cambie documentoE
  // Inicializamos los requisitos agregando campos "activado" y "seleccionado"

  //Función para abrir el checklist
  const selectedCheckList = async (id_acto) => {
    if (selectedActo == 0) {
      setIsAlert(true);
    } else {
      //console.log("id_acto", id_acto);
      setCheckListOpen(true);
      const data = {
        id_acto: id_acto,
      };

      try {
        const res = await axios.post(requisitos, data);
        console.log("res data checklist", res.data);
        /* if (res) {
          console.log(res.data);
        }*/
        setDocumento(res.data[1]);
        setName_LegalAct(res.data[0]);
      } catch (error) {
        console.log("no se logro enviar el id_acto", error);
      }
    }
  };

  //console.log("lista de otorgantes", otorgante);

  //Funciones para eliminar otorgantes y adquirientes

  const otorgante_Eliminar = (nombre, razon_social) => {
    //console.log("nombre ", nombre, "razon social", razon_social);
    // Filtramos los que no coinciden con el ID que queremos eliminar
    if (nombre !== "undefined undefined undefined") {
      //console.log(" se ejecuto en undefined undefined undefined");
      const nuevosOtorgantes = otorgante.filter((item) => {
        if (typeof item === "string") {
          return item !== nombre;
        } else {
          const nombre_completo = `${item.ap_paterno} ${item.ap_materno} ${item.nombre}`;
          return nombre_completo !== nombre;
        }
      });
      // Actualizamos el estado global con los nuevos valores
      setOtorgante(nuevosOtorgantes);

      //console.log("Otorgante eliminado:", id_eliminar);
    } else if (razon_social !== undefined) {
      const nuevosOtorgantes = otorgante.filter((item) => {
        if (item.razon_social === razon_social) {
          //console.log("Se eliminó:", item.razon_social);
          return false;
        }
        return true;
      });
      setOtorgante(nuevosOtorgantes);
      return;
    }
  };

  const adquiriente_Eliminar = (nombre, razon_social) => {
    //console.log("se esta ejecutando adquiriente eliminar");
    //console.log("nombre", nombre, "razon social", razon_social);
    //console.log("nombre ", nombre, "razon social", razon_social);
    // Filtramos los que no coinciden con el ID que queremos eliminar
    if (nombre !== "undefined undefined undefined") {
      //console.log(" se ejecuto en undefined undefined undefined");
      const nuevosAdquirientes = adquiriente.filter((item) => {
        if (typeof item === "string") {
          return item !== nombre;
        } else {
          //console.log("se ejecuto en nombre");
          const nombre_completo = `${item.ap_paterno} ${item.ap_materno} ${item.nombre}`;
          return nombre_completo !== nombre;
        }

        return true;
      });

      // Actualizamos el estado global con los nuevos valores
      //console.log("antiguo", adquiriente)
      //console.log("nuevas actualizaciones", nuevosAdquirientes)
      setAdquiriente(nuevosAdquirientes);

      //console.log("Otorgante eliminado:", id_eliminar);
    } else if (razon_social !== undefined) {
      const nuevosAdquirientes = adquiriente.filter((item) => {
        if (item.razon_social === razon_social) {
          //console.log("Se eliminó:", item.razon_social);
          return false;
        }
        return true;
      });
      setAdquiriente(nuevosAdquirientes);
      return;
    }
  };

  // console.log("archivos del expediente", archive);

  const getExp = async () => {
    try {
      const res = await axios.post(expedientesphp, {
        data: search,
      });
      console.log("res data expedientes", res.data);
      if (Array.isArray(res.data) && res.data.length === 0) {
        setDataEmpty(true);
        console.log("No se encontraron datos para el expediente buscado");
        setMsg("No se encontraron datos para el expediente buscado");
        //setisAlert4(true);
        setShowFormulario(false);
      } else {
        setDataEmpty(false);
        setShowFormulario(true);
      

      deleteDocumentosGuardados();

      //Datos generales del expediente
      setExp_Consecutivo(res.data.expediente.consecutivo);

      setNo_Escritura(res.data.expediente.no_escritura);

      setfecha_firma(res.data.expediente.fecha_firma);
      setArchive([]);

      //Otorgantes
      if (res.data.otorgantes == 0) {
        setOtorgante([]);
      } else {
        let otorgantesArray = [];
        Object.values(res.data.otorgantes).forEach((item) => {
          otorgantesArray.push(item);
        });
        //console.log("otorgantes array", otorgantesArray);
        setOtorgante(otorgantesArray);
      }
      //Adquirientes
      if (res.data.adquirientes == 0) {
        setAdquiriente([]);
      } else {
        let adquirientesArray = [];
        Object.values(res.data.adquirientes).forEach((item) => {
          adquirientesArray.push(item);
        });
        //console.log("adquirientes array", adquirientesArray);
        setAdquiriente(adquirientesArray);
      }
      //setAdquiriente(res.data.adquirientes);

      if (res.data.archivos !== 0) {
        var nombreFechas = {};
        res.data.archivos.forEach((item) => {
          //nombreFechas[item.nombre_archivo] = item.fecha_vigencia;
          nombreFechas = { ...nombreFechas, [item.nombre]: item.vigencia };
        });
        //console.log("nombrefechas", nombreFechas);
        setFechas(nombreFechas);
        setArchive(res.data.archivos);
        //  console.log("archivos", res.data.archivos);
        //setArchive(res.data.archivos);
      }
      //setIsFirstLoad(res.data.inmuebles.valores);

      handleChangeSelectRama(res.data.acto_j.id_rama);

      try {
        const resListactos = await axios.post(getActosPhp, {
          data: res.data.acto_j.id_rama,
        });
        var list_actos_inicial = resListactos.data;
      } catch (error) {
        console.error("Error al obtener actos juridicos", error);
      }

      handleChangeSeletActos(res.data.acto_j.id_acto);
      setSelectedActo(res.data.acto_j.id_acto);

      const idABuscar = parseInt(res.data.acto_j.id_acto);
      // console.log("idabuscar", idABuscar);
      //  console.log("lista de actos", list_actos_inicial);

      // 2. Usar .find() para obtener el objeto (el Acto) que coincide con ese ID
      const actoEncontrado = list_actos_inicial.find(
        (acto) => acto.id_acto == idABuscar,
      );
      //   console.log("acto encontrado", actoEncontrado);

      // 3. Imprimir el objeto encontrado (si se encontró)
      /*console.log("ID a buscar:", idABuscar);
    console.log("Lista de actos:", listActos);
    console.log("Acto encontrado:", actoEncontrado);*/

      //Enviamos el acto encontrado para obtener su nombre y documentos necesarios
      //Si no se encuentra, enviamos 0 para que no haya error en la logica de la palomita
      if (actoEncontrado) {
        setName_LegalAct_verification(actoEncontrado);
      } else {
        setName_LegalAct_verification(0);
      }

      
      if (res.data.acto_j.id_variante !== "0") {
        //console.log("entro a variante", res.data.acto_j.id_variante);

      let resVariante = await axios.post(getVariantsPhp, {
        data: res.data.acto_j.id_acto,
      });
      const arrayVariantes = resVariante.data;

      //  console.log("data variante", resVariante.data);
      let valor_variantes_seleccionado = res.data.acto_j.id_variante;

      const variante = arrayVariantes.find(
        (item) => valor_variantes_seleccionado >= item.id_variante,
      );

      // console.log("lista variantes", listVariantes);
      //  console.log("variante seleccionada", variante);

      handleChangeSelectVariantes(
        variante.id_variante,
        res.data.acto_j.id_acto,
      );
      setSelectedIdVariante(variante.id_variante);
      setSelectedVarainte(variante.id_variante);

      try {
        const data = {
          id_acto: res.data.acto_j.id_acto,
          id_variante: variante.id_variante,
        };
        const res_options = await axios.post(getOptions, data);
        //console.log("res options", res_options)
        if (res_options.data.length > 0) {
          setListOpciones(res_options.data);
          //   console.log("data opciones", res_options.data);
          var variante_opcion = res_options.data.find(
            (item) => variante.id_variante >= item.id_variante,
          );
          //   console.log("variante elegida", variante_opcion.id_variante);
          handleChangeSelectOpcion(
            variante_opcion.id_variante,
            res.data.acto_j.id_acto,
          );
        }
      } catch (error) {
        console.error("Error al obtener Opciones", error);
      }

    } else {
        //handleChangeSelectVariantes(0, res.data.acto_j.id_acto);
        setSelectedIdVariante(0);
        setSelectedVarainte(0);
        setListOpciones([]);
        //handleChangeSelectOpcion(0, res.data.acto_j.id_acto);
    }

      setExpedientes(res.data);

      //Inmuebles
      setInputNumeroInmuebles(res.data.inmuebles.no_inmuebles);

      handleInputNoIn(res.data.inmuebles.no_inmuebles);

      //console.log("num_inmuebles", res.data.inmuebles.no_inmuebles);

      //Valores de los inmuebles
      //let num_inmuebles = res.data.inmuebles.valores;
      //console.log("num_inmuebles", Object.values(num_inmuebles)[0]);
      //console.log("valor operacion", res.data.inmuebles.valores)

      //setInmueble(res.data.inmuebles);
      //setInmuebleBackup(res.data.inmuebles);
      //Archivos de expediente
      //console.log("archivos del expediente", res.data.archivos);
      //Base valor
      setBaseValor(res.data.inmuebles.base_valor);

      setIsFirstLoad(res.data.inmuebles.valores);

      //Establecemos las fechas de los archivos por nombre
      //console.log("res data archivos", res.data.archivos);

      //console.log("fecha de firma del expediente", res.data.expediente.fecha_firma);

      /*   const clientesArray = Object.entries(res.data).map(([id, nombre]) => ({
          id,
          nombre,
        }));
        setClientes(clientesArray);



      /*
      if (res.data) {
        //Hacemos que se muestre el formulario
        setShowFormulario(true);
        setMsg("");
        //Rellenamos el formulario
        //Datos generales del expediente
        setExp_Consecutivo(res.data.expediente.consecutivo);

        setNo_Escritura(res.data.expediente.no_escritura);

        setfecha_firma(res.data.expediente.fecha_firma);
        //Otorgantes
        if (res.data.otorgantes == 0) {
          setOtorgante([]);
        } else {
          let otorgantesArray = [];
          Object.values(res.data.otorgantes).forEach((item) => {
            otorgantesArray.push(item);
          });
          //console.log("otorgantes array", otorgantesArray);
          setOtorgante(otorgantesArray);
        }
        //Adquirientes
        if (res.data.adquirientes == 0) {
          setAdquiriente([]);
        } else {
          let adquirientesArray = [];
          Object.values(res.data.adquirientes).forEach((item) => {
            adquirientesArray.push(item);
          });
          //console.log("adquirientes array", adquirientesArray);
          setAdquiriente(adquirientesArray);
        }
        //setAdquiriente(res.data.adquirientes);
        //Datos del acto juridico
        setSelectedRama(res.data.acto_j.id_rama);
        setIsSelectActo(true);

        try {
          let resActos = await axios.post(getActosPhp, {
            data: res.data.acto_j.id_rama,
          });
          setListActos(resActos.data);
        } catch (error) {
          console.error("Error al obtener actos juridicos", error);
        }
        setSelectedActo(res.data.acto_j.id_acto);

        setIsSelectVariante(true);

        try {
          let resVariante = await axios.post(getVariantsPhp, {
            data: res.data.acto_j.id_acto,
          });
          const arrayVariantes = resVariante.data;
          setListVariantes(arrayVariantes);
          console.log("data variante", resVariante.data);
          let valor_variantes_seleccionado = res.data.acto_j.id_variante;

          const variante = arrayVariantes.find(
            (item) => valor_variantes_seleccionado >= item.id_variante,
          );

          if (variante) {
            setSelectedVarainte(variante.id_variante);
          }

          // Validaciónes si hay actos variantes
          //console.log("array variantes", arrayVariantes);
          if (arrayVariantes.length === 0) {
            var datavar = {
              id_acto: res.data.acto_j.id_acto,
              id_variante: 0,
            };
            console.log("datavar", datavar);
            console.log("se ejecuto");

            const resImp = await axios.post(getTaxes, datavar);

            setResImpuesto(parseInt(resImp.data));
            setIsSelectVariante(false);
            setIsSelecOpcion(false);
          }
        } catch (error) {
          console.error("Error al obtener variantes", error);
        }

        //Opciones
        if (res.data.acto_j.id_variante !== 0) {
          setIsSelecOpcion(true);
          const data = {
            id_acto: res.data.acto_j.id_acto,
            id_variante: res.data.acto_j.id_variante,
          };
          try {
            const res = await axios.post(getOptions, data);
            const arrayOpciones = res.data;
            console.log("data opciones", res.data);
            setListOpciones(arrayOpciones);
            // console.log("array opciones", data);
            if (arrayOpciones.length === 0) {
              setIsSelecOpcion(false);
              // Obtener impuestos
              const resImp = await axios.post(getTaxes, data);
              setResImpuesto(parseInt(resImp.data));
            }
          } catch (error) {
            console.error("Error al obtener Opciones", error);
          }
        } else {
          setIsSelecOpcion(false);
        }




        

        //Inmuebles
        setInputNumeroInmuebles(res.data.inmuebles.no_inmuebles);

        handleInputNoIn(res.data.inmuebles.no_inmuebles);

        //Valores de los inmuebles
        //let num_inmuebles = res.data.inmuebles.valores;
        //console.log("num_inmuebles", Object.values(num_inmuebles)[0]);
        //console.log("valor operacion", res.data.inmuebles.valores)

        //setInmueble(res.data.inmuebles);
        //setInmuebleBackup(res.data.inmuebles);
        //Archivos de expediente
        //console.log("archivos del expediente", res.data.archivos);
        //Base valor
        setBaseValor(res.data.inmuebles.base_valor);

        //Establecemos las fechas de los archivos por nombre
        //console.log("res data archivos", res.data.archivos);
        if (res.data.archivos !== 0) {
          var nombreFechas = {};
          res.data.archivos.forEach((item) => {
            //nombreFechas[item.nombre_archivo] = item.fecha_vigencia;
            nombreFechas = { ...nombreFechas, [item.nombre]: item.vigencia };
          });
          //console.log("nombrefechas", nombreFechas);
          setFechas(nombreFechas);
          setArchive(res.data.archivos);
        }
        setIsFirstLoad(res.data.inmuebles.valores);

        //console.log("fecha de firma del expediente", res.data.expediente.fecha_firma);
      } else {
        setMsg("No se encontraron expedientes con ese folio");
        setIsAlert6(true);
      }*/

      /*   const clientesArray = Object.entries(res.data).map(([id, nombre]) => ({
          id,
          nombre,
        }));
        setClientes(clientesArray);

        if (inputRef.current) {
          AutoComplete_Create(inputRef.current.id, clientesArray, 10);
        }*/
}
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    //console.log("isFirstLoad cambió:", isFirstLoad);

    Object.values(isFirstLoad).forEach((item, index) => {
      handleChangeOperacion(item.valor_operacion, index);
      handleChangeComercial(item.valor_comercial, index);
      handleChangeCatastral(item.valor_catastral, index);
    });
  }, [isFirstLoad]);

  return (
    <>
    
      {!ocultarFormulario ? (
        <>
          <>
            <hr />
            <h5 className="mt-3">Edición de un expediente</h5>
            <p>
              Realice la busqueda de información del expediente comenzando con
              el consecutivo del mismo.
            </p>

            <MDBRow>
              <MDBCol size="10"> 
                <MDBInput
                  ref={inputRef}
                  id="search_Exp"
                  label="Consecutivo del expediente"
                  value={search}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Solo números y puntos
                    if (/^[0-9.]*$/.test(value)) {
                      setSearch(value);
                    }
                  }}
                />
              </MDBCol>
              <MDBCol size="2">
                <MDBBtn className="w-100" onClick={getExp}>
                  Buscar
                </MDBBtn>
              </MDBCol>
            </MDBRow>

            {/*search &&
              search.map((expediente) => (
                <div key={expediente.id_expediente} className="mt-3 p-3 border">
                  <h6>Consecutivo: {expediente.consecutivo}</h6>
                  <p>Nombre del titular: {expediente.nombre_titular}</p>

                  <MDBBtn
                    onClick={() =>
                      handleEditExpediente(expediente.id_expediente)
                    }
                  >
                    Editar expediente
                  </MDBBtn>
                </div>
              ))*/}

              

            {showFormulario == true ? (
              <>
                <CheckListModal
                  checkListOpen={checkListOpen}
                  setCheckListOpen={setCheckListOpen}
                  name_legalact={name_legalact}
                  documento={documento}
                ></CheckListModal>

                <>
                  {/* Select Ramas */}
                  <div className="mt-3 container">
                    <MDBRow
                      className="align-items-start"
                      style={{ marginBottom: "20px" }}
                    >
                      <div
                        className="fieldset-container mt-4"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          gap: "5px",
                        }}
                      >
                        <span className="fieldset-title">
                          Datos generales del expediente
                        </span>

                        <MDBRow className="mb-2 mt-3">
                          <MDBCol>
                            <h5>Consecutivo del expediente</h5>
                          </MDBCol>
                          <MDBCol>
                            <MDBInput
                              value={exp_Consecutivo}
                              label="Consecutivo del expediente"
                              disabled
                            />
                          </MDBCol>
                        </MDBRow>
                        <MDBRow>
                          <MDBCol>
                            <h5>No. de escritura</h5>
                          </MDBCol>
                          <MDBCol>
                            <MDBInput
                              value={no_escritura}
                              label="No. de escritura"
                              disabled
                            />
                          </MDBCol>
                        </MDBRow>

                        <MDBRow className="mt-2 d-flex justify-content-end">
                          <MDBCol>
                            <h5>Fecha de firma</h5>
                          </MDBCol>
                          <MDBCol>
                            <DatePicker
                              disabled
                              selected={
                                fecha_firma && fecha_firma !== "0000-00-00"
                                  ? (() => {
                                      const parts = fecha_firma.split("-");
                                      return new Date(
                                        parts[0],
                                        parts[1] - 1,
                                        parts[2],
                                      );
                                    })()
                                  : null
                              }
                              onChange={(date) => {
                                /* console.log("Objeto Date que llega:", date);
                                    console.log("getFullYear():", date.getFullYear());
                                    console.log("getMonth() + 1:", date.getMonth() + 1);
                                    console.log("getDate():", date.getDate());
                                    console.log("toISOString():", date.toISOString());
                                    console.log(
                                      "toISOString().split('T')[0]:",
                                      date.toISOString().split("T")[0]
                                    ); */

                                setfecha_firma(
                                  date.toISOString().split("T")[0],
                                );
                              }}
                              dateFormat="yyyy-MM-dd"
                              placeholderText="Fecha de firma"
                              className="form-control"
                              wrapperClassName="w-100"
                              showYearDropdown
                              scrollableYearDropdown
                              yearDropdownItemNumber={100}
                              //ref={customInputRef}
                              customInput={<CustomDateInput />}
                            />
                          </MDBCol>
                        </MDBRow>
                      </div>

                      <div
                        className="fieldset-container mt-4"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          gap: "5px",
                        }}
                      >
                        <span className="fieldset-title">Acto jurídico</span>

                        <div className="d-flex align-items-center mt-1">
                          <Form.Select
                            className="form-select mt-3"
                            onChange={handleChangeSelectRama}
                            value={selectedRama}
                          >
                            <option value={0} key={0}>
                              Seleccionar una rama
                            </option>
                            {listRamas.map((element) => (
                              <option
                                value={element.id_rama}
                                key={element.id_rama}
                              >
                                {element.nombre}
                              </option>
                            ))}
                          </Form.Select>
                        </div>

                        {/* Actos Juridicos */}
                        {isSelectActo && (
                          <div className="d-flex align-items-center mt-1">
                            <Form.Select
                              className="form-select mt-3 me-4"
                              value={selectedActo}
                              onChange={handleChangeSeletActos}
                            >
                              <option value={0} key={0}>
                                Seleccionar un acto
                              </option>
                              {listActos.map((element) => (
                                <option
                                  value={element.id_acto}
                                  key={element.id_acto}
                                >
                                  {element.nombre}
                                </option>
                              ))}
                            </Form.Select>
                            <button
                              onClick={() => selectedCheckList(selectedActo)}
                              className="me-3 mt-3 bg-transparent border-0 position-relative cursor-pointer"
                              style={{ width: "40px", height: "40px" }}
                            >
                              <i className="fas fa-clipboard-list fa-2x position-absolute top-0 start-0"></i>

                              {documentosGuardados
                                ?.find(
                                  (grupo) =>
                                    grupo?.[1] ===
                                    verification_legalact?.nombre,
                                )?.[0]
                                ?.every(
                                  (doc) =>
                                    doc?.seleccionado === 1 ||
                                    doc?.activar === 1,
                                ) &&
                                verification_legalact !== 0 &&
                                selectedActo !== 0 && (
                                  <div>
                                    <img
                                      src={palomita}
                                      alt="palomita"
                                      className="position-absolute top-0 start-0"
                                      style={{ width: "40px" }}
                                    />
                                  </div>
                                )}
                            </button>
                          </div>
                        )}
                        {/* Variantes */}
                        {isSelectVariante && (
                          <Form.Select
                            className="form-select mt-3"
                            value={selectedVariante}
                            onChange={handleChangeSelectVariantes}
                          >
                            <option value={0} key={0}>
                              Seleccionar una variante
                            </option>
                            {listVariantes.map((element) => (
                              <option
                                value={element.id_variante}
                                key={element.id_variante}
                              >
                                {element.nombre}
                              </option>
                            ))}
                          </Form.Select>
                        )}
                        {/* Opciones */}
                        {isSelectOpcion && (
                          <Form.Select
                            className="form-select mt-3"
                            value={selectedOpcion}
                            onChange={handleChangeSelectOpcion}
                          >
                            <option value={0} key={0}>
                              Seleccionar una opción
                            </option>
                            {listOpciones.map((element) => (
                              <option
                                value={element.id_variante}
                                key={element.id_variante}
                              >
                                {element.nombre}
                              </option>
                            ))}
                          </Form.Select>
                        )}

                        {/* Form */}

                        {resImpuesto !== undefined && (
                          <>
                            <div>
                              <Modal
                                size="lg"
                                centered
                                show={showModal}
                                onHide={() => setShowModal(false)}
                              >
                                <Modal.Header>
                                  <Modal.Title>Aviso de Cotización</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  La cotización se ha guardado con éxito, ¿Desea
                                  imprimir la cotización?
                                </Modal.Body>
                                <Modal.Footer className="mx-100">
                                  <MDBBtn
                                    className=""
                                    color="danger"
                                    onClick={() => window.location.reload()}
                                  >
                                    No, solo guardar
                                  </MDBBtn>
                                  <MDBBtn color="success" onClick={handlePrint}>
                                    Sí, imprimir PDF
                                  </MDBBtn>
                                </Modal.Footer>
                              </Modal>
                            </div>

                            {resImpuesto !== 0 ? (
                              <div className="mt-4">
                                <MDBRow className="mb-3">
                                  <MDBCol>
                                    <h5>Número de inmuebles / fracciones</h5>
                                  </MDBCol>
                                  <MDBCol>
                                    <MDBInput
                                      type="number"
                                      onChange={handleInputNoIn}
                                      value={inputNumeroInmuebles}
                                      onWheel={(e) => e.target.blur()}
                                      min={0}
                                    />
                                  </MDBCol>
                                </MDBRow>
                                {/* Inmuebles */}
                                <div>{renderComponents()}</div>
                                <MDBRow className="mt-3">
                                  <MDBCol size={3}>
                                    <h5>Municipio de aplicación</h5>
                                  </MDBCol>
                                  <MDBCol>
                                    <Form.Select
                                      className="form-select"
                                      onChange={handleBaseValorSelect}
                                      value={baseValor}
                                    >
                                      <option value={0} key={0}>
                                        Selecciona municipio
                                      </option>
                                      {selectData.map((items) => (
                                        <option
                                          value={items.value}
                                          key={items.value}
                                        >
                                          {items.text}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </MDBCol>
                                </MDBRow>

                                {/* 
          <MDBRow className="mt-4">
            {msg !== "" && <p style={{ color: "red" }}>{msg}</p>}

            <MDBBtn rounded onClick={handleClickCotizar} color="success">
              Cotizar
            </MDBBtn>
          </MDBRow>



          {(!showIframe && boolElemento) && (

          <MDBRow className="d-flex justify-content-between align-items-center my-4">
            <MDBCol className="col-auto">
              <button
                className="btn btn-warning"
                onClick={() => window.location.reload()}
                style={{
                  borderRadius: "8px",
                  fontWeight: "bold",
                }}
              >
                ⟵
              </button>
            </MDBCol>
          </MDBRow>
          )}

          */}

                                {showIframe && (
                                  <>
                                    <MDBRow className="mt-5">
                                      <MDBCol>
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: resPonse,
                                          }}
                                        />
                                      </MDBCol>
                                    </MDBRow>

                                    <MDBRow className="d-flex justify-content-between align-items-center my-4">
                                      {/* 
                <MDBCol className="col-auto">
                  <button
                    className="btn btn-warning"
                    onClick={() => window.location.reload()}
                    style={{
                      borderRadius: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    ⟵
                  </button>
                </MDBCol>
            
                <MDBCol className="col-auto">
                  <MDBBtn onClick={handleOnClickSave}>
                    Guardar Cotización
                  </MDBBtn>
                </MDBCol>

                */}
                                    </MDBRow>
                                  </>
                                )}
                              </div>
                            ) : (
                              <>
                                {/**
          <MDBRow className="mt-4">
            <MDBBtn color="success" onClick={handleCLickSinInmbuebles}>
              Cotizar
            </MDBBtn>
          </MDBRow>

           */}

                                {!showIframe2 && (
                                  <MDBRow className="d-flex justify-content-between align-items-center my-4">
                                    {/*

            <MDBCol className="col-auto">
              <button
                className="btn btn-warning"
                onClick={() => window.location.reload()}
                style={{
                  borderRadius: "8px",
                  fontWeight: "bold",
                }}
              >
                ⟵
              </button>
            </MDBCol>

             */}
                                  </MDBRow>
                                )}

                                {showIframe2 && (
                                  <>
                                    <MDBRow className="mt-4 justify-content-center align-items-center">
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: resPonse,
                                        }}
                                      />
                                    </MDBRow>

                                    <MDBRow className="d-flex justify-content-between align-items-center my-4">
                                      {/*
                <MDBCol className="col-auto">
                  <button
                    className="btn btn-warning"
                    onClick={() => window.location.reload()}
                    style={{
                      borderRadius: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    ⟵
                  </button>
                </MDBCol>

                <MDBCol className="col-auto">
                  <MDBBtn onClick={handleOnClickSave}>
                    Guardar Cotización
                  </MDBBtn>
                </MDBCol>

                 */}
                                    </MDBRow>
                                  </>
                                )}
                              </>
                            )}
                          </>

                          //Si el formulario se muestra, se desativa el boton
                        )}
                      </div>
                    </MDBRow>

                    <>
                      <Modal_Clientes
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        isAdquiriente={isAdquiriente}
                      />
                      <>
                        {" "}
                        <MDBRow
                          className="align-items-start"
                          style={{ marginBottom: "20px" }}
                        >
                          <div
                            className="fieldset-container mt-4"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                              gap: "5px",
                            }}
                          >
                            <div style={{ gap: "10px" }}>
                              <span className="fieldset-title">Otorgantes</span>

                              {otorgante && otorgante.length > 0 ? (
                                <>
                                  {otorgante.map((o, index) => {
                                    if (typeof o === "string") {
                                      var nombre_completo_otorgante = o;
                                    } else {
                                      var nombre_completo_otorgante = `${o.ap_paterno} ${o.ap_materno} ${o.nombre}`;
                                    }

                                    //console.log("otorgante", o);

                                    return (
                                      <div
                                        key={index}
                                        className="d-flex align-items-center mb-2"
                                      >
                                        <button
                                          type="button"
                                          className="p-0 border-0 bg-transparent me-2"
                                          onClick={() =>
                                            otorgante_Eliminar(
                                              nombre_completo_otorgante,
                                              o.razon_social,
                                            )
                                          }
                                        >
                                          <img
                                            src={tache}
                                            width="40px"
                                            height="25px"
                                            alt="Eliminar"
                                          />
                                        </button>

                                        {o.razon_social ? (
                                          <MDBInput
                                            label="Otorgante"
                                            value={o.razon_social}
                                            className="pe-5"
                                            readOnly
                                          />
                                        ) : (
                                          <>
                                            <MDBInput
                                              label="Otorgante"
                                              value={nombre_completo_otorgante}
                                              className="pe-5"
                                              readOnly
                                            />
                                          </>
                                        )}
                                      </div>
                                    );
                                  })}
                                </>
                              ) : (
                                <></>
                              )}
                            </div>

                            <div className="d-flex justify-content-end">
                              {/* Input */}

                              {/* Botón */}
                              <button
                                type="button"
                                onClick={abrirModal_Otorgantes}
                                className="btn btn-warning d-flex justify-content-center align-items-center"
                                style={{
                                  fontSize: "14px",
                                  height: "28px",
                                  width: "30px",
                                }}
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </MDBRow>
                        <MDBRow
                          className="align-items-start"
                          style={{ marginBottom: "20px" }}
                        >
                          <div
                            className="fieldset-container"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                              gap: "5px",
                            }}
                          >
                            <div style={{ gap: "10px" }}>
                              <span className="fieldset-title">
                                Adquirientes
                              </span>

                              {adquiriente && adquiriente.length > 0 ? (
                                <>
                                  {adquiriente.map((adquirientes, index) => {
                                    // Concatenamos los nombres

                                    if (typeof adquirientes === "string") {
                                      var nombre_completo_adquiriente =
                                        adquirientes;
                                    } else {
                                      var nombre_completo_adquiriente = `${adquirientes.ap_paterno} ${adquirientes.ap_materno} ${adquirientes.nombre}`;
                                    }

                                    return (
                                      <div
                                        key={index}
                                        className="d-flex align-items-center mb-2"
                                      >
                                        <button
                                          type="button"
                                          className="p-0 border-0 bg-transparent me-2"
                                          onClick={() => {
                                            adquiriente_Eliminar(
                                              nombre_completo_adquiriente,
                                              adquirientes.razon_social,
                                            );
                                          }}
                                        >
                                          <img
                                            src={tache}
                                            width="40"
                                            height="25"
                                            alt="icono"
                                          />
                                        </button>
                                        {adquirientes.razon_social ? (
                                          <>
                                            <MDBInput
                                              label="Adquirientes"
                                              value={adquirientes.razon_social}
                                              className="pe-5"
                                              readOnly
                                            />
                                          </>
                                        ) : (
                                          <>
                                            <MDBInput
                                              label="Adquirientes"
                                              value={
                                                nombre_completo_adquiriente
                                              }
                                              className="pe-5"
                                              readOnly
                                            />
                                          </>
                                        )}
                                      </div>
                                    );
                                  })}
                                </>
                              ) : (
                                <></>
                              )}
                            </div>

                            <div className="d-flex justify-content-end">
                              <button
                                type="button"
                                onClick={abrirModal_Adquirientes}
                                className="btn btn-warning d-flex justify-content-center align-items-center"
                                style={{
                                  fontSize: "14px",
                                  height: "28px",
                                  width: "30px",
                                }}
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </MDBRow>
                      </>

                      <MDBRow
                        className="align-items-start"
                        style={{ marginBottom: "20px" }}
                      >
                        <div
                          className="fieldset-container"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                          }}
                        >
                          <span className="fieldset-title">
                            Archivos de expediente
                          </span>

                          <div>
                            {archive.map((fileName, index) => {
                              const expirar =
                                typeof fileName === "object"
                                  ? file_date(
                                      fileName?.vigencia,
                                      fileName?.fecha_carga,
                                    )
                                  : null;

                              const nombreArchivo =
                                typeof fileName === "string"
                                  ? fileName
                                  : (fileName?.nombre ?? "");

                              return (
                                <div
                                  key={index}
                                  className="border p-2 m-2 flex items-center gap-2"
                                  style={{
                                    backgroundColor: expirar
                                      ? "#fe8484ff"
                                      : "#ffffff",
                                  }}
                                >
                                  <MDBRow>
                                    <MDBCol size="auto">
                                      <button
                                        type="button"
                                        className="p-0 border-0 bg-transparent"
                                        onClick={() =>
                                          delete_files(nombreArchivo)
                                        }
                                      >
                                        <img
                                          src={tache}
                                          width="40px"
                                          height="25px"
                                          alt="icono"
                                        ></img>
                                      </button>
                                    </MDBCol>
                                    <MDBCol>
                                      <p className="m-0">{nombreArchivo}</p>
                                    </MDBCol>
                                    <MDBCol>
                                      <MDBInput
                                        label="Captura la vigencia en número de meses"
                                        type="number"
                                        value={
                                          typeof fileName === "object"
                                            ? fechas[fileName.nombre] || ""
                                            : fechas[fileName] || ""
                                        }
                                        ref={archivo_fecharef}
                                        onWheel={(e) => e.target.blur()}
                                        onChange={(e) => {
                                          const months = parseInt(
                                            e.target.value || 0,
                                            10,
                                          );

                                          const key =
                                            typeof fileName === "object"
                                              ? fileName.nombre
                                              : fileName;

                                          setFechas((prev) => ({
                                            ...prev,
                                            [key]: months,
                                          }));
                                        }}
                                      />
                                    </MDBCol>
                                  </MDBRow>
                                </div>
                              );
                            })}
                          </div>

                          <div className="d-flex justify-content-end">
                            <button
                              type="button"
                              onClick={handleOpenModal}
                              className="btn btn-primary mb-2"
                            >
                              Subir Archivos
                            </button>
                          </div>
                        </div>
                      </MDBRow>
                    </>
                  </div>

                  <>
                    <Alerts
                      isShow={isAlert}
                      variant="danger"
                      head="Aviso"
                      msg="El acto jurídico no esta seleccionado"
                      clicked={() => setIsAlert(false)}
                      textButton="OK"
                    />
                  </>

                  <Alerts
                    isShow={isAlerts3}
                    variant="danger"
                    head="Aviso"
                    msg={msg}
                    clicked={() => setIsAlert3(false)}
                    textButton="OK"
                  />

                  <Alerts
                    isShow={isalert4}
                    variant="danger"
                    head="Aviso"
                    msg={msg}
                    clicked={() => {
                      handleOnClickSave(); // ejecuta la función de guardado
                      setDetectarCambios(false); // reinicia el estado
                      setisAlert4(false); // cierra la alerta
                    }}
                    textButton="OK"
                  />

                  <Alert_modal
                    show={detectarCambios && isAlert5}
                    onHide={() => {
                      setDetectarCambios(false);
                      setIsAlert5(false);
                      handleOnClickSave();
                    }}
                    title="Aviso"
                    message="Se volverá a calcular el presupuesto."
                    variantButton="primary"
                    textButton="Aceptar"
                  />

                  <MDBRow className="d-flex justify-content-between align-items-center my-4">
                    <MDBCol className="col-auto">
                      <button
                        className="btn btn-warning"
                        onClick={() => window.location.reload()}
                        style={{
                          borderRadius: "8px",
                          fontWeight: "bold",
                        }}
                      >
                        ⟵
                      </button>
                    </MDBCol>

                    <MDBCol className="col-auto">
                      <button className="btn btn-primary" onClick={() => detectChanges()}>
                        Siguiente
                      </button>
                    </MDBCol>
                  </MDBRow>
                </>
              </>
            ): (<>
            
              <Alerts
                    isShow={dataEmpty}
                    variant="danger"
                    head="Aviso"
                    msg={msg}
                    clicked={() => setDataEmpty(false)}
                    textButton="OK"
                  />
            
            </>)}
          </>
        </>
      ) : (
        <>
          {!dateSearch ? (
            <>
              <hr />
              <h5 className="mt-3">
                Integración / formalización de un expediente nuevo
              </h5>
              <p>
                A continuación puede editar los montos correspondientes a los
                impuestos y honorarios del presupuesto.
              </p>

              <MDBRow className="mt-5">
                <MDBCol>
                  <div 
                  ref = {quotationRef}
                  dangerouslySetInnerHTML={{ __html: resPonse }} />
                </MDBCol>
              </MDBRow>

              <MDBRow className="d-flex justify-content-between align-items-center my-4">
                <MDBCol className="col-auto">
                  <button
                    className="btn btn-warning"
                    onClick={devolver}
                    style={{
                      borderRadius: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    ⟵
                  </button>
                </MDBCol>

                <MDBCol className="col-auto">
                  <button
                    className="btn btn-primary"
                    onClick={save_information}
                  >
                    Guardar
                  </button>
                </MDBCol>
              </MDBRow>
            </>
          ) : (
            <>
              <Alerts
                isShow={dateSearch}
                variant="success"
                head="Aviso"
                msg={`El expediente se guardo correctamente bajo el folio: ${fol}`}
                clicked={() => setIsCreated(true)}
                textButton="OK"
              />

            
            </>
          )}
        </>
      )}


    </>
  );
};

export default Integration;
